import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import PageSizeSelector from '../../components/PageSizeSelector';

const Pagination = ({ paginated, page, setPage, filtered, totalPages, total, pageSize, setPageSize }) => {
  const { t } = useTranslation();
  // D-15: prefer the server-supplied `total` over filtered.length —
  // filtered.length is bounded by the current page size, so the
  // "Showing X of Y" line used to lie ("Showing 20 of 20" with 60
  // rows on the server). Falls back to filtered.length when `total`
  // is undefined (older callers).
  const displayTotal = typeof total === 'number' ? total : filtered.length;
  // Range display "1-20 of 65", "21-40 of 65" etc. Anjani flagged that
  // the label sat at "20 of 65" on every page (missing the from
  // component). Compute from server-authoritative page + PAGE_SIZE
  // (X-02: PAGE_SIZE now user-selectable via the pageSize prop;
  // falls back to 20 when the caller hasn't wired the selector).
  const PAGE_SIZE = typeof pageSize === 'number' ? pageSize : 20;
  const from = displayTotal === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
  const to = (page - 1) * PAGE_SIZE + paginated.length;
  return (
    <div
      style={{
        padding: '14px 32px',
        borderTop: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <span style={{ fontSize: 13, color: S.textMuted }}>
        {t('offers.list.showingCount', { shown: paginated.length, total: displayTotal, from, to, defaultValue: 'Showing {{from}}-{{to}} of {{total}} offers' })}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {typeof pageSize === 'number' && setPageSize && (
          <PageSizeSelector pageSize={pageSize} setPageSize={setPageSize} />
        )}
        <div style={{ display: 'flex', gap: 4 }}>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
          <button
            key={p}
            onClick={() => setPage(p)}
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              border: p === page ? `1px solid ${S.burgundy}` : `1px solid ${S.borderLight}`,
              background: p === page ? 'rgba(128,0,32,0.07)' : '#fff',
              color: p === page ? S.burgundy : S.textSecondary,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {p}
          </button>
        ))}
        </div>
      </div>
    </div>
  );
};

export default Pagination;
